import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import ClassView from '@routes/Home/routes/AdminPortal/routes/Calendars/routes/ClassView';
import SectionCalendar from '@routes/Home/routes/AdminPortal/routes/Calendars/routes/SectionCalendar';
import TeacherView from '@routes/Home/routes/AdminPortal/routes/Calendars/routes/TeacherView';
import TeachersCalendar from '@routes/Home/routes/AdminPortal/routes/Calendars/routes/TeachersCalendar';

const CalendarsLazy = React.lazy(
	() => import(/* webpackChunkName : 'CalendarsLazy' */ './components')
);

export default (store) => {
	return {
		path: 'calendars',
		element: <AsyncLoading component={<CalendarsLazy />} />,
		children: [
			ClassView(store),
			SectionCalendar(store),
			TeacherView(store),
			TeachersCalendar(store),
		],
	};
};
